<!-- 监测点图表按钮点击传送至监测点图表 -->

<template>
  <i class='el-icon-data-line mr-5 cursor-pointer' @click='toChart' :title="$t('integration.monitoring_point_chart')"></i>
</template>
<script>
// import { carrierProbeHistory } from '@/utils/winDetail'
import { sampleValueHistory } from '../../utils/winDetail'

export default {
  props: {
    carrierId: null,
    carrierName: null,
    sceneId: null,
    carrierType: null

  },
  methods: {
    toChart () {
      sampleValueHistory({
        carrierId: this.carrierId,
        sceneId: this.sceneId,
        carrierName: this.carrierName,
        carrierType: this.carrierType
      })
    }
  }
}
</script>
